<ng-container *transloco="let t; read: 'configuration'">
<div class="rounded-sm fix-action-row modal-body">
  <div class="flex justify-between border-b mb-2">
    <h1 class="text-[25px] font-bold mr-2">{{ t('schoolYears.addNew') }}</h1>
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
  </div>

  <div mat-dialog-content>
    <form class="grid grid-cols-1" [formGroup]="schoolYearForm">

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-normal" for="schoolYearName">{{ t('schoolYears.schoolYearLabel') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('schoolYears.formatPlaceholder')" autocomplete="off" id="schoolYearName" type="text"
            formControlName="schoolYearName" required>
        </mat-form-field>
      </div>
      <div class="col-span-1 items-center w-[100%]">
        @if (schoolYearName.errors?.pattern && (schoolYearName.value.length < 7 || schoolYearName.value.length > 6)) {
          <span
            class="text-center text-sm text-red-700">
            {{ t('schoolYears.invalidFormat') }}
          </span>
        }
      </div>
    </form>
  </div>

  <div class="spacer"></div>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <button mat-button mat-dialog-close>{{ t('common.cancel') }}</button>
    <drdp-btn mat-button (click)="onSubmit()" [disabled]="schoolYearForm.invalid" cdkFocusInitial>
      {{ t('common.save') }}
    </drdp-btn>
  </div>
</div>
</ng-container>
